'use strict';
(() => {
  const dialog = document.querySelector('#ascaim-consent');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const ageKey = 'ascaim_adult_v1';
  const ageCookie = '__Host-ascaim_adult_v1';
  const age = dialog.querySelector('#welcome-adult');
  const error = dialog.querySelector('#welcome-error');
  const cancel = dialog.querySelector('#welcome-cancel');
  const purposes = ['preferences', 'analytics', 'marketing'];
  const inputs = Object.fromEntries(purposes.map(p => [p, dialog.querySelector('#welcome-' + p)]));
  let adult = false, opener = null, apiRequest = null;
  try { adult = sessionStorage.getItem(ageKey) === 'yes'; } catch {}
  // Session cookie shares an explicit confirmation across tabs on this host.
  // No expiry or Max-Age: do not turn this into a persistent age exemption.
  try { adult = adult || document.cookie.split(';').some(c => c.trim() === ageCookie + '=yes'); } catch {}
  function privacy() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (apiRequest) return apiRequest;
    apiRequest = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Datenschutzdienst nicht erreichbar')), 10000);
      if (!window.Shopify?.loadFeatures) { clearTimeout(timer); reject(new Error('Shopify nicht erreichbar')); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => {
        clearTimeout(timer);
        if (err || !window.Shopify.customerPrivacy) reject(new Error('Datenschutzdienst nicht erreichbar'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(err => { apiRequest = null; throw err; });
    return apiRequest;
  }
  function show(trigger) {
    opener = trigger || null;
    age.checked = adult;
    cancel.hidden = !adult;
    error.textContent = '';
    if (!dialog.open) dialog.showModal();
    privacy().then(api => {
      const consent = api.currentVisitorConsent();
      purposes.forEach(p => { inputs[p].checked = consent[p] === 'yes'; });
    }).catch(() => { error.textContent = 'Die Cookie-Einstellungen sind gerade nicht erreichbar. Bitte versuche das Speichern erneut.'; });
  }
  function close() { dialog.close(); opener?.focus(); }
  async function save(necessary) {
    if (!age.checked) { error.textContent = 'Bitte bestätige zuerst, dass du mindestens 18 Jahre alt bist.'; age.focus(); return; }
    const buttons = [...dialog.querySelectorAll('.welcome-actions button')];
    buttons.forEach(b => { b.disabled = true; });
    error.textContent = '';
    try {
      const api = await privacy();
      const selection = Object.fromEntries(purposes.map(p => [p, !necessary && inputs[p].checked]));
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Speichern fehlgeschlagen')), 10000);
        api.setTrackingConsent(selection, result => {
          clearTimeout(timer);
          if (result?.error) reject(new Error('Speichern fehlgeschlagen')); else resolve();
        });
      });
      adult = true;
      try { sessionStorage.setItem(ageKey, 'yes'); } catch {}
      try { document.cookie = ageCookie + '=yes; Path=/; Secure; SameSite=Lax'; } catch {}
      close();
    } catch {
      error.textContent = 'Deine Auswahl konnte nicht gespeichert werden. Bitte versuche es erneut.';
    } finally { buttons.forEach(b => { b.disabled = false; }); }
  }
  dialog.querySelector('#welcome-necessary').onclick = () => save(true);
  dialog.querySelector('#welcome-selected').onclick = () => save(false);
  cancel.onclick = close;
  dialog.querySelector('#welcome-minor').onclick = () => {
    adult = false; age.checked = false; cancel.hidden = true;
    try { sessionStorage.removeItem(ageKey); } catch {}
    try { document.cookie = ageCookie + '=; Path=/; Secure; SameSite=Lax; Max-Age=0'; } catch {}
    error.textContent = 'Unser Angebot richtet sich ausschließlich an Erwachsene ab 18 Jahren. Du kannst die Seite schließen. Datenschutz und Impressum bleiben über die Links erreichbar.';
  };
  dialog.addEventListener('cancel', event => { if (!adult) event.preventDefault(); });
  document.querySelectorAll('[data-ascaim-cookie-settings]').forEach(button => { button.onclick = () => show(button); });
  // Legal information must remain accessible without age confirmation or consent.
  const legal = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:policies(?:\/|$)|pages\/(?:vertrag-widerrufen|widerrufsbelehrung-und-formular|jugendschutz|datenschutz-homepage)(?:\/|$))/i.test(location.pathname);
  if (!legal && !adult) show();
  else privacy().then(api => {
    const consent = api.currentVisitorConsent();
    if (!legal && purposes.some(p => !['yes', 'no'].includes(consent[p]))) show();
  }).catch(() => { if (!legal) show(); });
})();
